module.exports = __webpack_public_path__ + "static/media/loading-sandwatch.463c3f82.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading-sandwatch.gif
// module id = 824
// module chunks = 0